<div class="the_container">

  <span class="details-text ng-star-inserted">Point of Contacts</span>

  <div class="d-flex filter-details">
    <div class="d-flex filter-div">
      <div class="state-filter">
        <mat-form-field class="select-mat-form-field custom-select-form">
          <mat-select class="custom-mat-select custom-select" id="state" placeholder="Select State"
            [formControl]="selectedState">
            @for (state of stateList; track $index) {
            <mat-option [value]="state">
              {{ state }}
            </mat-option>
            }
          </mat-select>
        </mat-form-field>
      </div>

      <div class="state-filter">
        <mat-form-field class="select-mat-form-field custom-select-form">
          <mat-select class="custom-mat-select custom-select" id="district" placeholder="Select District"
            [formControl]="districtName">
            <mat-option value="ALL DISTRICT">ALL DISTRICT</mat-option>
            @for (district of districtList[stateName]; track $index) {
            <mat-option *ngIf="district !== null && district !== ''" [value]="district">
              {{ district }}
            </mat-option>

            }
          </mat-select>
        </mat-form-field>
      </div>

    </div>
  </div>
  <div class="card-container">
    <!-- District Level User Card (shown only if districtUser exists) -->
    @if (districtUsers?.length) {
    <div class="card">
      <div class="card-head">
        <span>{{ districtUsers[0]?.user_role }}</span>
      </div>
      @for (user of districtUsers; track user) {
      <div class="Contact-details">
        <p>
          <span class="name">{{ user.name }}</span>
          <span class="contact">{{ user.alt_contact_no }}</span>
        </p>
        <div style="border-bottom: 2px solid var(--bg-tertiary);" *ngIf="$index!=districtUsers.length-1"></div>

      </div>
      }

    </div>
    }



    <!-- State Level User Card (shown if districtUser or stateUser exists) -->
    @if ((stateUsers?.length || districtUsers?.length) && stateUsers?.length) {
    <div class="card">
      <div class="card-head">
        <span>{{ stateUsers?.[0]?.user_role || 'STATE LEVEL USER' }}</span>
      </div>
      @for (user of stateUsers; track $index) {
      <div class="Contact-details">
        <p>
          <span class="name">{{ user.name }}</span>
          <span class="contact">{{ user.alt_contact_no }}</span>
        </p>
        <div style="border-bottom: 2px solid var(--bg-tertiary);" *ngIf="$index!=stateUsers.length-1"></div>
      </div>
      }
    </div>
    }
    <div class="card">
      <div class="card-head">
        <span> CENTRAL LEVEL USER </span>
      </div>
      @if(superUser){
      @for (user of superUser; track $index) {
      <div class="Contact-details">
        <p>
          <span class="name">{{ user.name }}</span>
          <span class="contact">{{ user.alt_contact_no }}</span>
        </p>
      </div>
      }
      }
    </div>


    <div class="card">
      <div class="card-head">
        <span> Satsang IT Wing, Deoghar (10.00 AM - 8.00 PM)  (WhatsApp Recommended) </span>
      </div>
      @if(supportUser){
      <div class="Contact-details">
        <p>
          <span class="name">{{ supportUser.name }}</span>
          <span class="contact">{{ supportUser.contact_no }}</span>
        </p>
      </div>
      }
    </div>
  </div>
</div>